module.exports = __webpack_public_path__ + "static/media/placeholder.7ac7d2de.svg";